import React, { useState, useEffect } from "react";
import back from "../../assets/borrow/back.svg";
import gen from "../../assets/borrow/gen.svg";
import { useBorrow } from "../../contexts/borrowContext/borrowContext";
import { createVault } from "../../lib/stbContract";
import { useDashboard } from "../../contexts/dashboardContext";
import Big from "big.js";
import STC from "../../backend/build/contracts/STC.json";
import STB from "../../backend/build/contracts/STB.json";
import { batchFunction } from "../../lib/batch";



function Generate({
  onNextButtonClicked,
  onBackButtonClicked,
  _glmrPrice,
  _colRatio,
  _stb,
  _stc,
  _account,
  _web3,
  _batch,

}) {
  const { totalStcOut, totalglmrIn, handleGenerateSTCNext } = useBorrow();

  const { handleLoading } = useDashboard()

    // Find call data for the functions
    


  //handles generate click event
  const handleGenerate = async () => {
    const maxU256 = 115792089237316195423570985008687907853269984665640564039457584007913129639935n;
    const stbAddress = _stb.options.address;
    const approveCallData =  _web3.eth.abi.encodeFunctionCall({
      name: "approve",
      type: "function",
      inputs: [{
          type: "address",
          name: "spender"
      },{
          type: "uint256",
          name: "amount"
      }]
  }, [stbAddress, maxU256]);

  const amountAttached = _web3.utils.toWei(String(totalglmrIn), "ether");
  const createVaultCallData =  _web3.eth.abi.encodeFunctionCall({
    name: "createVault",
    type: "function",
    inputs: [{
        type: "uint256",
        name: "collateral_amt"
    }]
  }, [amountAttached]);
  const addresses = [_stc.options.address, stbAddress];
  const callData = [approveCallData, createVaultCallData];
  const values = [0, amountAttached];
  const gasLimits = [];
  handleLoading();
  await batchFunction(_batch, addresses, values, callData, gasLimits, _account).then((res) => {

    handleLoading()
    handleGenerateSTCNext(res);
  });
  };

  return (
    <div className="bg-[#292C31] rounded-[12px] flex flex-col gap-[4vh] w-[735px] py-[2vh] px-[86px] ">
      <div className="flex flex-col gap-[2vh] font-bold ">
        <div className="flex items-center justify-between">


          <h1 className="text-[] ">Total GLMR to Deposit Amount:</h1>

          <p>${(totalglmrIn * _glmrPrice).toFixed(4)}</p>

        </div>
        <div className="flex items-center justify-between">
          <h1>Total STC To Generate Amount:</h1>
          <p>${totalStcOut}</p>
        </div>
        <div className="flex items-center justify-between">


          <h1>GLMR To Deposit:</h1>
          <p>{totalglmrIn}</p>


        </div>
        <div className="flex items-center justify-between">
          <h1>STC To Generate:</h1>
          <p>{totalStcOut}</p>
        </div>
        <div className="flex items-center justify-between">


          <h1>Current GLMR Price:</h1>

          <p>${_glmrPrice}</p>

        </div>
        <div className="flex items-center justify-between">
          <h1>Liquidity Ratio:</h1>
          <p>{_colRatio}</p>
        </div>
      </div>
      <p className="text-center text-[.75rem] ">
        <span className="text-[#865DFF] ">Note:</span> Total GLMR Amount may vary
        depending on price action but GLMR to deposit must be the same verify on
        your wallet before you approve transaction. Thanks
      </p>
      <div className="flex items-center justify-center gap-[110px] mt-[3.19vh] mb-[3.5vh] text-[.75rem] ">
        <button
          className="border border-[#009FBD] w-[8.54vw] h-[5.95vh] rounded-lg flex items-center justify-center gap-2 bg-inherit hover:opacity-75 "
          onClick={onBackButtonClicked}
        >
          <img src={back} alt="" className="w-[1.25vw] h-[1.25vw] " />
          Back
        </button>
        <button
          className="bg-[#009FBD] w-[8.54vw] h-[5.95vh] rounded-lg flex items-center justify-center gap-2  hover:bg-opacity-75 "
          onClick={handleGenerate}
        >
          Generate
          <img src={gen} alt="" className="w-[1.25vw] h-[1.25vw] " />
        </button>
      </div>
    </div>
  );
}

export default Generate;
